import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"

const UpdateForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const [formData, setFormData] = useState({
        public_id: "",
        serial_number: "",
        lock_number: "",
        contact_number: "",
    })
    const {public_id, serial_number, lock_number, contact_number} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect (() => {
        if (location.state){
            const {data} = location.state
            setFormData((prev) => ({
                ...prev,
                public_id: data.public_id,
                serial_number: data.serial_number,
                lock_number: data.lock_number,
                contact_number: data.contact_number
            }))
        }

    }, [location])

    const onChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const paylaod = {contact_number}
        updateUnBill(paylaod)
    }
    
    const updateUnBill = async (paylaod) => {
        setIsLoading(true)
        try {
            const response = await Server.put(`/un-billed/${public_id}/update`, paylaod)
            if (response.status === 200){
                toast.success(response.data.detail)
                navigate('/un-billed-serverside')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else {
                toast.error('unknown error occurred. please try again')
            }
        }
    }


    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update UnBill Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="serial_number"
                                type="text"
                                label="MeterID"
                                value={serial_number}
                                onChange={onChange}
                                error={errors.serial_number}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="lock_number"
                                type="text"
                                label="LockID"
                                disabled="disabled"
                                value={lock_number}
                                onChange={onChange}
                                error={errors.lock_number}
                            />
                        </div>
                        <div className="col-md-4">
                            <InputField
                                name="contact_number"
                                type="text"
                                label="Contact"
                                value={contact_number}
                                onChange={onChange}
                                error={errors.contact_number}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default UpdateForm
